import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { VestingTask } from '../../types/vesting-tasks.types';
import { useAppQuery } from '../use-app-query.hook';

export const useTargetBasedVestingTasksByPlan = ({
  companyId,
  sharePlanId,
}: {
  companyId: string;
  sharePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { data: approveTargetBasedSharePlans = [], isLoading } = useAppQuery<VestingTask[]>({
    queryKey: [QueryKey.GET_APPROVE_TARGET_BASED_VESTING_TASKS, companyId, sharePlanId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'share-plans', sharePlanId, 'target-based-vesting-approve'],
      }),
    enabled: !!companyId && !!sharePlanId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_APPROVE_TARGET_BASED_VESTING_TASKS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    approveTargetBasedSharePlans,
    isLoading,
  };
};
